import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Box, Typography } from "@mui/material";

interface Props {
  data: {
    label: string;
    sublabel?: string;
    kindLabel?: string;
    color: string;
    borderColor: string;
    handleColor: string;
  };
}

const PipelineGenericNode: React.FC<Props> = ({ data }) => (
  <Box
    sx={{
      position: "relative",
      bgcolor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
      borderLeft: `3px solid ${data.borderColor}`,
      borderRadius: 1,
      px: 1.25,
      py: 0.75,
      width: 160,
      cursor: "pointer",
      transition: "background-color 0.15s, border-color 0.15s",
      "&:hover": {
        bgcolor: "action.hover",
        borderColor: data.borderColor,
        borderLeftColor: data.borderColor,
      },
    }}
  >
    <Handle
      type="target"
      position={Position.Left}
      style={{
        background: data.handleColor,
        width: 6,
        height: 6,
        border: "none",
      }}
    />
    <Handle
      type="source"
      position={Position.Right}
      style={{
        background: data.handleColor,
        width: 6,
        height: 6,
        border: "none",
      }}
    />
    <Typography
      variant="caption"
      sx={{
        color: "text.primary",
        fontWeight: 600,
        fontSize: "0.72rem",
        display: "block",
        lineHeight: 1.3,
      }}
    >
      {data.label}
    </Typography>
    {data.kindLabel && (
      <Typography
        sx={{
          color: data.borderColor,
          fontSize: "0.55rem",
          fontWeight: 600,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          display: "block",
          lineHeight: 1.2,
          mt: 0.25,
        }}
      >
        {data.kindLabel}
      </Typography>
    )}
    {data.sublabel && (
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontSize: "0.62rem",
          display: "block",
          mt: 0.25,
          lineHeight: 1.2,
        }}
      >
        {data.sublabel}
      </Typography>
    )}
  </Box>
);

export default PipelineGenericNode;
